import { combineSlices } from "@reduxjs/toolkit";
import {
  companyDataSlice,
  complementaryDataSlice,
  countriesSlice,
  createAccountSlice,
  createDemoSlice,
  initialDataSlice,
  mediaListSlice,
  productTypesSlice,
  salesChannelsListSlice,
  salesChannelsSlice,
  userDataSlice
} from "./slices";

const onBoardingSlice = combineSlices(
  companyDataSlice,
  complementaryDataSlice,
  countriesSlice,
  createAccountSlice,
  createDemoSlice,
  initialDataSlice,
  mediaListSlice,
  productTypesSlice,
  salesChannelsSlice,
  salesChannelsListSlice,
  userDataSlice
);

export default onBoardingSlice;
